'use strict';

const Backbone = require('backbone');

const ProcessPermission = Backbone.Model.extend({
    defaults: {
        permit: false
    },
    isPermitted: function(context) {
        if(context.getGroupRole().isAdmin()) {
            return true;
        }

        return this.get('permit');
    }
}, {
    type: null
});

const ActionViewPermission = ProcessPermission.extend({
    defaults: {
        permit_when: false,
    },
    isPermitted: function (context) {
        const action = context.getAction();

        // root アクションは見れる
        if (!action.getParent()) {
            return true;
        }

        // 管理者権限ならば見れる
        if(context.getGroupRole().isAdmin()) {
            return true;
        }

        // always ならば見れる
        const permitWhen = this.get('permit_when');
        if(permitWhen == 'always') {
            return true;
        }


        // 担当者ならば見れる
        if(permitWhen == 'assigned') {
            const user = context.getUser();
            const assignees = action.getAssignees();
            return _.contains(assignees, user);
        }

        return false;
    }
}, {
    type: 'action:view'
})

const ActionCreatePermission = ProcessPermission.extend({
}, {
    type: 'action:create'
});

const ActionEditPermission = ProcessPermission.extend({
    defaults: {
        permit_when: false
    },
    isPermitted: function(context) {
        if(context.getGroupRole().isAdmin()) {
            return true;
        }

        const permitWhen = this.get('permit_when');
        if(permitWhen == 'always') {
            return true;
        }

        if(permitWhen == 'assigned') {
            const user = context.getUser();
            const assignees = context.getAction().getAssignees();
            return _.contains(assignees, user);
        }

        return false;
    }
}, {
    type: 'action:edit'
});

const ActionBulkImportPermission = ProcessPermission.extend({
}, {
    type: 'action:import'
});

module.exports = {
    ProcessPermissions: [
        ActionViewPermission,
        ActionCreatePermission,
        ActionEditPermission,
        ActionBulkImportPermission
    ],
    ActionViewPermission: ActionViewPermission,
    ActionEditPermission: ActionEditPermission,
    ActionCreatePermission: ActionCreatePermission,
    ActionBulkImportPermission: ActionBulkImportPermission
};



// WEBPACK FOOTER //
// ./process/domain/entity/permission.js